import React from "react";

const ProgressBar = (props) => (
  <div className="adobe-progress-bar">
    <img
      alt="loading icon"
      className="bff-spinner-gif"
      src="https://cdn.brandfolder.io/27C9EC93/at/qdh7e1-cbakhk-47987g/bff-spinner.gif"
    />
    {props.message}
  </div>
);

export default ProgressBar;
